import { memo } from 'react';

import { PublicHeaderTitle } from '~/components/v2/components/shared/PublicHeaderTitle';
import { getPublicShowcasePageTitle } from '~/components/v2/components/showcase/getPublicShowcasePageTitle';
import { usePublicShowcaseCurrentSubPage } from '~/components/v2/components/showcase/hooks/usePublicShowcaseCurrentSubPage';
import { usePublicShowcaseContext } from '~/providers/PublicShowcaseProvider';

/**
 * Wire `type: 'title'` block: no payload of its own — it displays the current page's name (the
 * collection name on Home, the sub-page name inside one). Same heading chrome as the page header
 * so the two cannot visually drift.
 */
export const PublicShowcaseTitleBlock = memo(() => {
  const { collection } = usePublicShowcaseContext();
  const currentSubPage = usePublicShowcaseCurrentSubPage();
  const title = getPublicShowcasePageTitle({
    collectionName: collection.name,
    currentSubPageName: currentSubPage?.subPage.name,
  });

  return (
    <div className="px-4 py-3" data-testid="PUBLIC_COLLECTION_TITLE_BLOCK">
      <PublicHeaderTitle dataTestId="PUBLIC_COLLECTION_TITLE_BLOCK_TITLE" title={title} />
    </div>
  );
});

PublicShowcaseTitleBlock.displayName = 'PublicShowcaseTitleBlock';
